/* @flow */
import prefixStyles from "./utils/prefixStyles";

const breakpoint = {
  THERMOSTAT_DETAILS_HEADER: 490,
  IPAD_WIDTH: 768,
};

const button = {
  RADIUS: "4px",
};

const font = {
  WEIGHT_BOLD: 700,
};

// The notch for iPhone X added safe-area-inset-top CSS properties. Unfortunately,
// iOS 11 uses constant(safe-area-inset-top), iOS 11.2 uses env(safe-are-inset-top)
let safeAreaFunction = null;
// $FlowIgnore CSS can be defined globally, which is why the typeof check is here
if (typeof CSS !== "undefined" && typeof CSS.supports === "function") {
  if (CSS.supports("padding-top", "constant(safe-area-inset-top)")) {
    safeAreaFunction = "constant";
  } else if (CSS.supports("padding-top", "env(safe-area-inset-top)")) {
    safeAreaFunction = "env";
  }
}

const padding = {
  CONTENT: 14.25,
  APP_BAR_BUTTON: 4,
  SAFE_AREA_TOP: safeAreaFunction
    ? `${safeAreaFunction}(safe-area-inset-top)`
    : "0px",
  SAFE_AREA_RIGHT: safeAreaFunction
    ? `${safeAreaFunction}(safe-area-inset-right)`
    : "0px",
  SAFE_AREA_BOTTOM: safeAreaFunction
    ? `${safeAreaFunction}(safe-area-inset-bottom)`
    : "0px",
  SAFE_AREA_LEFT: safeAreaFunction
    ? `${safeAreaFunction}(safe-area-inset-left)`
    : "0px",
};

const styles = prefixStyles({
  flexLayout: {
    display: "flex",
    alignItems: "center",
  },
  flexStretch: {
    flex: "1 1 auto",
  },
  flexStretchEqual: {
    flex: "1 1 100%",
  },
  flexShrink: {
    flex: "0 1 auto",
    minWidth: 0, // fixes a bizarre bug with text-overflow
  },
  flexFixed: {
    flex: "0 0 auto",
  },
  textEllipsis: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
});

const zIndexLayers = {
  BASE: 0,
  CONTENTS: 1000,
  MODAL: 2000,
  POPUP: 3000,
};

export default {
  Breakpoint: breakpoint,
  Button: button,
  Font: font,
  Padding: padding,
  RESPONSIVE_REFRESH_RATE: 250,
  Styles: styles,
  zIndexLayers,
};



// WEBPACK FOOTER //
// ../nx-components/src/Theme.js